
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { Client } from "src/app/Models/client";
import { ClientService } from "src/app/Services/client.service";
import { StorageService } from "../../../Services/storage.service";

@Component({
    selector: "app-account-confirmation",
    imports: [TranslateModule],
    templateUrl: "./account-confirmation.component.html",
    styleUrl: "./account-confirmation.component.scss"
})
export class AccountConfirmationComponent implements OnInit {
  emailConfirmed!: boolean;
  isLoading: boolean = true;

  constructor(
    private storage: StorageService,
    private route: ActivatedRoute,
    private router: Router,
    private clientService: ClientService,
  ) {}

  ngOnInit(): void {
    //read the token from current route
    const token: string = this.route.snapshot.paramMap.get("token") || "";

    //send the token to the server to be checked
    this.clientService.confirmAccount(token).subscribe({
      next: (client: Client) => {
        if (client.id) {
          this.isLoading = false;
          this.emailConfirmed = true;
        }

        //store a property accountConfirmed (so we can hide the registration popup in the home page after confirmation)
        this.storage.setItem("openLoginDialogue", String(this.emailConfirmed));
        //redirect to home after account confirmation
        setTimeout(() => {
          this.router.navigate(["/"]);
        }, 2000);
      },
      error: (err) => {
        console.error(err);
        this.isLoading = false;
        this.emailConfirmed = false;
      },
    });
  }
}
